<template>
  <div id="sig-container" class="block full form-horizontal">
    <!--tree :treeData="treeData"></tree-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Crear-EditarUsuario",
  components: {
    //Tree: () => import("../../template-fga/components/form/Tree/TreeComponent")
  },
  data: () => {
    return {
      params: {
        usuario_id: null
      },
      modulos: {},
      errors: null,
      treeData: [
        {
          id: 1,
          descripcion: "sidebar",
          titulo: "Sidebar",
          icono: "",
          tooltip: "",
          imagen: "",
          clase: "",
          url: "",
          open: false,
          draggable: "true",
          acciones: [
            {
              id: "Ver-1",
              permiso_id: "Ver-1",
              descripcion: "Ver",
              disabled: "csscheckbox-info",
              checked: false
            },
            {
              id: "Crear-1",
              permiso_id: "Crear-1",
              descripcion: "Crear",
              disabled: "csscheckbox-info",
              checked: false
            },
            {
              id: "Editar-1",
              permiso_id: "Editar-1",
              descripcion: "Editar",
              disabled: "csscheckbox-info",
              checked: false
            },
            {
              id: "Eliminar-1",
              permiso_id: "Eliminar-1",
              descripcion: "Eliminar",
              disabled: "csscheckbox-info",
              checked: false
            }
          ],
          accion: {
            Ver: false,
            Crear: false,
            Editar: false,
            Eliminar: false
          },
          eventos: [
            {
              icono: "fa fa-plus",
              evento: "registrarModulo"
            },
            {
              icono: "fa fa-pencil",
              evento: "actualizarModulo"
            }
          ],
          children: [
            {
              id: 3,
              descripcion: "administrativo",
              titulo: "Administrativo",
              icono: "fa fa-cog",
              tooltip: "",
              imagen: "",
              clase: "",
              url: "",
              open: false,
              draggable: "true",
              acciones: [
                {
                  id: "Ver-3",
                  permiso_id: "Ver-3",
                  descripcion: "Ver",
                  disabled: "csscheckbox-info",
                  checked: false
                },
                {
                  id: "Crear-3",
                  permiso_id: "Crear-3",
                  descripcion: "Crear",
                  disabled: "csscheckbox-info",
                  checked: false
                },
                {
                  id: "Editar-3",
                  permiso_id: "Editar-3",
                  descripcion: "Editar",
                  disabled: "csscheckbox-info",
                  checked: false
                },
                {
                  id: "Eliminar-3",
                  permiso_id: "Eliminar-3",
                  descripcion: "Eliminar",
                  disabled: "csscheckbox-info",
                  checked: false
                }
              ],
              accion: {
                Ver: false,
                Crear: false,
                Editar: false,
                Eliminar: false
              },
              eventos: [
                {
                  icono: "fa fa-plus",
                  evento: "registrarModulo"
                },
                {
                  icono: "fa fa-pencil",
                  evento: "actualizarModulo"
                }
              ],
              children: [
                {
                  id: 2,
                  descripcion: "parametrizacion",
                  titulo: "Parametrización general",
                  icono: "fa fa-sliders fa-fw",
                  tooltip: "",
                  imagen: "",
                  clase: "sidebar-nav-mini-hide",
                  url: "/parametrizacion",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-2",
                      permiso_id: "Ver-2",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-2",
                      permiso_id: "Crear-2",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-2",
                      permiso_id: "Editar-2",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-2",
                      permiso_id: "Eliminar-2",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 4,
                  descripcion: "usuario",
                  titulo: "Usuario",
                  icono: "fa fa-user",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/usuario",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-4",
                      permiso_id: "Ver-4",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-4",
                      permiso_id: "Crear-4",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-4",
                      permiso_id: "Editar-4",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-4",
                      permiso_id: "Eliminar-4",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 5,
                  descripcion: "perfil",
                  titulo: "Perfil",
                  icono: "fa fa-users",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/perfil",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-5",
                      permiso_id: "Ver-5",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-5",
                      permiso_id: "Crear-5",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-5",
                      permiso_id: "Editar-5",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-5",
                      permiso_id: "Eliminar-5",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 6,
                  descripcion: "admin_modulos",
                  titulo: "Modulos",
                  icono: "fa fa-cubes",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/modulo",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-6",
                      permiso_id: "Ver-6",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-6",
                      permiso_id: "Crear-6",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-6",
                      permiso_id: "Editar-6",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-6",
                      permiso_id: "Eliminar-6",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 7,
                  descripcion: "cron",
                  titulo: "Cron",
                  icono: "fa fa-clock-o fa-fw",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/cron",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-7",
                      permiso_id: "Ver-7",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-7",
                      permiso_id: "Crear-7",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-7",
                      permiso_id: "Editar-7",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-7",
                      permiso_id: "Eliminar-7",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 8,
                  descripcion: "usuario_portal",
                  titulo: "Usuarios portal",
                  icono: "fa fa-user-secret",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/usuario/portal",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-8",
                      permiso_id: "Ver-8",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-8",
                      permiso_id: "Crear-8",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-8",
                      permiso_id: "Editar-8",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-8",
                      permiso_id: "Eliminar-8",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 9,
                  descripcion: "cargues_portal",
                  titulo: "Cargues del portal",
                  icono: "fa fa-archive",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/cargues_portal",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-9",
                      permiso_id: "Ver-9",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-9",
                      permiso_id: "Crear-9",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-9",
                      permiso_id: "Editar-9",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-9",
                      permiso_id: "Eliminar-9",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 10,
                  descripcion: "configuracion",
                  titulo: "Configuración",
                  icono: "fa fa-cogs fa-fw",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/configuracion",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-10",
                      permiso_id: "Ver-10",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-10",
                      permiso_id: "Crear-10",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-10",
                      permiso_id: "Editar-10",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-10",
                      permiso_id: "Eliminar-10",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                },
                {
                  id: 11,
                  descripcion: "estado_garantia",
                  titulo: "Estados de garantía",
                  icono: "fa fa-ticket",
                  tooltip: "",
                  imagen: "",
                  clase: "",
                  url: "/estados_garantia",
                  open: false,
                  draggable: "true",
                  acciones: [
                    {
                      id: "Ver-11",
                      permiso_id: "Ver-11",
                      descripcion: "Ver",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Crear-11",
                      permiso_id: "Crear-11",
                      descripcion: "Crear",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Editar-11",
                      permiso_id: "Editar-11",
                      descripcion: "Editar",
                      disabled: "csscheckbox-info",
                      checked: false
                    },
                    {
                      id: "Eliminar-11",
                      permiso_id: "Eliminar-11",
                      descripcion: "Eliminar",
                      disabled: "csscheckbox-info",
                      checked: false
                    }
                  ],
                  accion: {
                    Ver: false,
                    Crear: false,
                    Editar: false,
                    Eliminar: false
                  },
                  eventos: [
                    {
                      icono: "fa fa-plus",
                      evento: "registrarModulo"
                    },
                    {
                      icono: "fa fa-pencil",
                      evento: "actualizarModulo"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapGetters({ loading: "loading" })
  },
  methods: {
    index() {
      this.$store
        .dispatch("index", { endpoint: "arbol" })
        .then(response => {
          this.modulos = response;
          /*this.modulos.forEach(element => {
            console.log(element);
          });*/
        })
        .catch(() => {
          this.$notify({
            title: "Advertencia!",
            type: "warning",
            content: "Error cargando módulos"
          });
        });
      if (this.$route.params.id) {
        this.params.usuario_id = this.$route.params.id;
        this.$store
          .dispatch("index", {
            endpoint: "arbol",
            params: this.params
          })
          .then(response => {
            this.permisos = response;
          })
          .catch(() => {
            this.$notify({
              title: "Advertencia!",
              type: "warning",
              content: "Error cargando permisos"
            });
          });
      }
    }
  },
  mounted() {
    this.index();
  }
};
</script>